import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Reveal } from "@/components/site/Reveal";
import { company } from "@/data/content";

export const FinalCta = () => (
  <section className="bg-primary" data-testid="final-cta-section">
    <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-5 py-20 lg:grid-cols-12 lg:px-10 lg:py-28">
      <Reveal className="lg:col-span-7">
        <h2 className="max-w-xl text-3xl font-semibold tracking-tight text-primary-foreground sm:text-4xl lg:text-[42px] lg:leading-[1.15]">
          Plánujete rekonstrukci, zateplení nebo fasádu?
        </h2>
        <p className="mt-5 max-w-lg text-base leading-relaxed text-primary-foreground/75">
          Pošlete nám stručný popis a několik fotografií. Projekt s Vámi
          projdeme a navrhneme další postup.
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Button
            asChild
            data-testid="final-cta-primary"
            className="h-12 bg-primary-foreground px-7 text-primary hover:bg-primary-foreground/90"
          >
            <Link to="/#kontakt">
              Získat nezávaznou nabídku <ArrowRight className="ml-1 h-4 w-4" />
            </Link>
          </Button>
          <Button
            asChild
            variant="outline"
            data-testid="final-cta-phone"
            className="h-12 border-primary-foreground/30 bg-transparent px-7 text-primary-foreground hover:bg-primary-foreground/10 hover:text-primary-foreground"
          >
            <a href={company.phoneHref}>
              <Phone className="mr-1 h-4 w-4" /> Zavolat {company.phone}
            </a>
          </Button>
        </div>
      </Reveal>
      <Reveal delay={0.12} className="lg:col-span-5">
        <figure>
          <img
            src="./images/fasada-mestsky-dum.jpg"
            alt="Dokončená fasáda městského domu"
            className="h-72 w-full rounded-md object-cover lg:h-[420px]"
            loading="lazy"
          />
          <figcaption className="mt-2 text-xs text-primary-foreground/60">
            Fasáda městského domu · dokončená realizace
          </figcaption>
        </figure>
      </Reveal>
    </div>
  </section>
);
